import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveDamageAreas } from './index';

// Api's
import { damageAreaApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getDamageAreasSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      damageAreaApi.getByDamageArea
    );
    if (response.data.result) {
      yield put(saveDamageAreas(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveDamageAreas(null, true, resultError.messagesDataError));
    }
  }
}
